import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {Subscription} from "rxjs";
import {FormazioneStoreService} from "../_services/formazione-store.service";
import {ApiRestService} from "../_services/api-rest.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {RicercaPaginazione} from "../../Admin/models/sendpersonale";
import {Aula} from "../_Models/aula";
import {AuleEditComponent} from "../aule-edit/aule-edit.component";

@Component({
  selector: 'app-aule-list',
  templateUrl: './aule-list.component.html'
})
export class AuleListComponent implements OnInit {

  UserDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'nome',
    allowRemoteDataSearch:true,
    allowSearchFilter: true,
    searchPlaceholderText: "inserire almeno 3 caratteri",
  };
  subscriptions: Subscription = new Subscription();
  @Input() AuleSedi: Aula[] = [];
  @Input() sede: number;
  @Output() sedeChange = new EventEmitter<number>();
  @Output() AuleSediChange = new EventEmitter<Aula[]>();

  Aule: Aula[] = [];
  auleSelezionate: Aula[] = [];
  constructor(
    private Store: FormazioneStoreService,
    private apiRestService: ApiRestService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(this.Store.$aule.subscribe(x => {
      if (x && x.data && x.data.length > 0)
        this.Aule = x.data
    }));
  }
  Add(){
    if(this.auleSelezionate && this.auleSelezionate.length > 0 && this.auleSelezionate[0])
      this.AddTolist(this.auleSelezionate[0]);
  }
  AddTolist(item: Aula){
    if(item.id)
      this.AuleSedi.push(item);
  }
  AddNew(){
    this.Store.updateAula(new Aula());
    const editmodal = this.modalService.open(AuleEditComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<AuleEditComponent>editmodal.componentInstance).IsModal = true;
    (<AuleEditComponent>editmodal.componentInstance).SedeSelezionata = this.sede;
    (<AuleEditComponent>editmodal.componentInstance).updated.subscribe(data=>{});
    (<AuleEditComponent>editmodal.componentInstance).added.subscribe(data=> this.AddTolist(data));
  }
  filtroAule(item: string) {
    if (item.length >= 3) {
      this.Store.getAule(new RicercaPaginazione(item, 0, 1));
    }
  }
  editContact(item: Aula) {
    this.Store.updateAula(item);
    const editmodal = this.modalService.open(AuleEditComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<AuleEditComponent>editmodal.componentInstance).IsModal = true;
    (<AuleEditComponent>editmodal.componentInstance).added.subscribe(data=>{});
    // (<AuleEditComponent>editmodal.componentInstance).updated.subscribe(data=> item = data);
  }
  deleteContact(item: Aula) {
    const idx = this.AuleSedi.findIndex(x=>x.id == item.id);
    if(confirm("Sicuro di voler eliminare questo elemento dalla lista?") && idx > -1)
      this.apiRestService.DeleteAula(item).subscribe(()=>{
        this.AuleSedi.splice(idx,1);
      });
  }
}
